// Deps
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

/**
 * Collapse Slider Swiper
 * ------------------------------------------------------- *
 */
// eslint-disable-next-line camelcase
const video_slider = ( function( document ) {
	var options;
	var selector;
	var element;
	var swiper;
	Swiper.use([ Navigation, Pagination, Autoplay ]);

	const _instance = {};

	options = {
		loop: true,
		autoplay: {
			delay: 3000
		},
		disableOnInteraction: true,
		pagination: {
			clickable: true,
			el: '.swiper-pagination',
			type: 'bullets'
		}
	};

	selector = '.video-slider';
	element = false;

	function init() {
		var count;
		var pagination;
		element = document.querySelector( selector );

		if ( ! element ) {
			return;
		}

		count = element.querySelectorAll(  '.swiper-container .swiper-slide' ).length;
		pagination = element.querySelector( '.swiper-pagination' );

		if ( 1 === count ) {
			element.classList.add( 'disabled' );

			if ( pagination ) {
				element.classList.add( 'disabled' );
			}
		}

		swiper = new Swiper( selector, options );

		element.addEventListener( 'mouseenter', function( event ) {
			swiper.autoplay.stop();
		}, false );

		element.addEventListener( 'mouseleave', function( event ) {
			swiper.autoplay.start();
		}, false );
	}

	/**
	* Public
	*/
	_instance.init = function() {
		init();
	};

	return _instance;
}( document ) );

// eslint-disable-next-line camelcase
export default video_slider;
